module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-8-m1.21c77d42.jpg";